// extracted by mini-css-extract-plugin
export var MasonryGrid = "otherOffers-module--MasonryGrid--XPkC6";
export var MasonryGridColumn = "otherOffers-module--MasonryGridColumn--zyni9";
export var dropdown = "otherOffers-module--dropdown--nVJtG";
export var fixJumping = "otherOffers-module--fixJumping--+G5eN";
export var item = "otherOffers-module--item--wZJtc";
export var refin = "otherOffers-module--refin--shmsy";
export var section = "otherOffers-module--section--wFosY";
export var tagBlock = "otherOffers-module--tagBlock--GoqbN";
export var tagShort = "otherOffers-module--tagShort--Jzr-9";
export var tagTitle = "otherOffers-module--tagTitle--MfORj";
export var title = "otherOffers-module--title--RvO+B";